import { useState } from 'react';
import { downloadCsv, useJournalReport } from '../hooks/useReports';
import PrintButton from '../components/PrintButton';

export default function JournalReportPage() {
  const today = new Date();
  const yearStart = `${today.getFullYear()}-01-01`;
  const yearEnd = `${today.getFullYear()}-12-31`;

  const [dateFrom, setDateFrom] = useState(yearStart);
  const [dateTo, setDateTo] = useState(yearEnd);
  const [applied, setApplied] = useState({ dateFrom: yearStart, dateTo: yearEnd });

  const { data, isLoading, error } = useJournalReport(applied);

  // 仕訳ID単位でグルーピング
  const grouped = (() => {
    if (!data) return [];
    const map = new Map<string, typeof data>();
    for (const row of data) {
      const arr = map.get(row.entryId) ?? [];
      arr.push(row);
      map.set(row.entryId, arr);
    }
    return Array.from(map.entries()).map(([entryId, rows]) => ({ entryId, rows }));
  })();

  return (
    <div>
      <div className="page-header">
        <h2>仕訳帳</h2>
      </div>

      {error && <div className="error-banner">{(error as Error).message}</div>}

      <div className="card">
        <div className="toolbar">
          <label>
            日付From{' '}
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            日付To{' '}
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>
          <button className="primary" onClick={() => setApplied({ dateFrom, dateTo })}>
            表示
          </button>
          <button onClick={() => downloadCsv('/api/reports/journal', applied)}>CSV出力</button>
          <PrintButton />
        </div>
      </div>

      {isLoading && <div>読み込み中...</div>}

      {data && (
        <table>
          <thead>
            <tr>
              <th style={{ width: 100 }}>取引日付</th>
              <th>摘要</th>
              <th style={{ width: 80 }}>借/貸</th>
              <th>勘定科目</th>
              <th className="numeric" style={{ width: 130 }}>借方</th>
              <th className="numeric" style={{ width: 130 }}>貸方</th>
              <th style={{ width: 80 }}>状態</th>
            </tr>
          </thead>
          <tbody>
            {grouped.map(({ entryId, rows }) => {
              const head = rows[0];
              if (!head) return null;
              return rows.map((r, i) => (
                <tr key={r.lineId}>
                  {i === 0 ? (
                    <>
                      <td rowSpan={rows.length}>{head.entryDate}</td>
                      <td rowSpan={rows.length}>{head.description}</td>
                    </>
                  ) : null}
                  <td>{r.lineType === 'debit' ? '借方' : '貸方'}</td>
                  <td>
                    {r.accountCode} {r.accountName}
                  </td>
                  <td className="numeric">
                    {r.lineType === 'debit' ? r.amount.toLocaleString() : ''}
                  </td>
                  <td className="numeric">
                    {r.lineType === 'credit' ? r.amount.toLocaleString() : ''}
                  </td>
                  {i === 0 ? (
                    <td rowSpan={rows.length}>
                      {head.status === 'active' ? (
                        <span className="badge active">有効</span>
                      ) : (
                        <span className="badge voided">取消</span>
                      )}
                    </td>
                  ) : null}
                </tr>
              ));
            })}
            {grouped.length === 0 && (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center', padding: 24 }} className="text-muted">
                  該当する仕訳はありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
